import { Component } from '@angular/core';
import { DiscussionPageBaseComponent } from '../../shared/discussion-page-base/discussion-page-base.component';

@Component({
  selector: 'app-discussion-getting-started',
  standalone: true,
  imports: [DiscussionPageBaseComponent],
  template: `
    <app-discussion-page-base
      pageTitle="Getting Started"
      pageDescription="Welcome to NHA Discussions! Start here to learn about the platform, community guidelines, and how to participate in discussions."
      activeTab="getting-started"
      categoryType="GETTING_STARTED"
    ></app-discussion-page-base>
  `,
})
export class DiscussionGettingStartedComponent {}
